import { render, staticRenderFns } from "./TagPesquisaForm.vue?vue&type=template&id=14e8bec7&"
import script from "./TagPesquisaForm.vue?vue&type=script&lang=js&"
export * from "./TagPesquisaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports